module.exports = __webpack_public_path__ + "static/media/fa-brands-400.0017cc6d.svg";